import { StickyBottomBar } from "components";
import { stickyBottomBarVariantsMap } from "./StickyBottomBar.config";
import type { StickyBottomBarAdapterProps } from "./StickyBottomBar.d";

const StickyBottomBarAdapter = ({
  showStickyBottomBar = true,
  stickyBottomBarHeading,
  stickyBottomBarButtonText,
  stickyBottomBarBenefits,
  stickyBottomBarHideBenefits,
  stickyBottomBarVariant = "option-1",
}: StickyBottomBarAdapterProps) =>
  showStickyBottomBar ? (
    <StickyBottomBar
      heading={stickyBottomBarHeading}
      buttonText={stickyBottomBarButtonText}
      benefits={stickyBottomBarBenefits}
      hideBenefits={stickyBottomBarHideBenefits}
      variant={stickyBottomBarVariantsMap[stickyBottomBarVariant] || "basic"}
    />
  ) : null;

export default StickyBottomBarAdapter;
